<template>
    <KButton
        v-if="text && href"
        v-editable="blok"
        :as="isExternal ? 'a' : nuxtLink"
        :to="isExternal ? undefined : href"
        :href="isExternal ? href : undefined"
        :target="isExternal ? link.target || undefined : undefined"
        :rel="isExternal && link.target === '_blank' ? 'noopener noreferrer' : undefined"
        :variant="variant"
        @click="track"
    >
        {{ text }}
        <template
            v-if="icon"
            #icon-end
        >
            <Icon
                :name="iconName"
                aria-hidden="true"
            />
        </template>
    </KButton>
</template>

<script setup>
import { KButton } from '@vemedia/karibu'
import { isExternalStoryblokLink, storyblokLinkHref } from '~~/shared/storyblok-link'

const props = defineProps({
    blok: {
        type: Object,
        required: true,
    },
})

const nuxtLink = resolveComponent('NuxtLink')
const { capture } = useTracking()

const text = computed(() => String(props.blok.text || '').trim())
const link = computed(() => props.blok.link || {})
const href = computed(() => storyblokLinkHref(link.value))
const isExternal = computed(() => isExternalStoryblokLink(link.value))

const VARIANTS = new Set(['primary', 'secondary'])
const variant = computed(() => (VARIANTS.has(props.blok.variant) ? props.blok.variant : 'primary'))

const ICONS = {
    'arrow-right': 'tabler:arrow-right',
}
const icon = computed(() => (props.blok.icon && ICONS[props.blok.icon]) || '')
const iconName = computed(() => ICONS[props.blok.icon] || 'tabler:arrow-right')

function track() {
    capture('banner_button_clicked', {
        placement: 'page-with-banner',
        label: text.value,
        url: href.value,
    })
}
</script>
